import { Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from '../common/commonService';
import { statusIcons } from '../constant/dataConstant';
import { urlConstant } from '../constant/urlConstant';
import { Globals } from '../globals';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class InspectionService {
  private statusMap = {}
  private propertyMap = {}
  private getInspectionData = {}
  private categories = [];
  private inspections = [];


  constructor(
    private commonService: CommonService,
    private toasterService: ToasterService,
  ) { }

  getCategories() {
    if (!!this.categories && this.categories.length > 0) {
      return from([this.categories]);
    }
    return this.commonService.get<any>(`${urlConstant.ServiceRequest.categories}`).pipe(map((res) => {
      if (res.Status === '200') {
        this.categories = res.data.categories;
        return this.categories;
      }
      return  [];
    }));
  }

  getStatus(type: string) {
    if (!!this.statusMap[type] && this.statusMap[type].length > 0) {
      const data = [...this.statusMap[type]];
      return from([data]);
    }
    return this.commonService.get<any>(urlConstant.PropertyStatus.StatusGet + type).pipe(map((res) => {
      if (res.Status === '200') {
        this.statusMap[type] = (res.data && res.data.Status) || [];
        return [...this.statusMap[type]];
      }
      return  [];
    }));
  }

  getProperty(propertyId: string) {
    if (!!this.propertyMap[propertyId]) {
      return from([this.propertyMap[propertyId]]);
    }
    return this.commonService.get<any>(urlConstant.Property.GetPropertyByPropertyId + '?propertyId=' + propertyId).pipe(map((res) => {
      if (res.Status === '200') {
        this.propertyMap[propertyId] = (res.data && res.data.Property);
        return this.propertyMap[propertyId];
      }
      this.toasterService.pop('error', 'Error', res.message);
      return undefined;
    }));
  }

  getIcon(status) {
    return statusIcons[status] || statusIcons.OTHER;
  }

  getInspection(id: string, f_doc?: boolean, f_service?: boolean) {
    const params = {};
    params['f_doc'] = f_doc;
    params['f_service'] = f_service;
    const query = Object.keys(params).filter(k=>params[k]).map((k, index) => {
      return `${k}=${params[k]}`;
    }).join('&');
    return this.commonService.get<any>(`${urlConstant.Inspection.getInspectionById}/${id}?${query}`);
  }

  getAllInspectionByProperty(filter: any){
    const queryParam = Globals.jsonToQueryString(filter);
    return this.commonService.get<any>(`${urlConstant.Inspection.getInspections}?${queryParam}`)
  }

  getAllDoneInspections(formData: any){
    const queryParam = Globals.jsonToQueryString(formData);
    return this.commonService.get<any>(`${urlConstant.Inspection.getInspections}?${queryParam}`);
  }

  addInspection(formData: any) {
    return this.commonService.post(urlConstant.Inspection.addInspection, formData)

  }

  updateInspection(formData: any) {
    return this.commonService.put(`${urlConstant.Inspection.updateInspection}/${formData.id}`, formData)
  }

  updateInspectionStatus(data: any) {
    return this.commonService.post(urlConstant.Inspection.updateInspectionStatus, data)
  }

  changeAdhocToggle(toggle: any) {
    return this.commonService.put(urlConstant.Inspection.changeAdhocToggle+'?toggle='+ toggle)
  }
  addInspectionSection(formData: any) {
    return this.commonService.post(urlConstant.Inspection.addInspectionSection, formData)
  }

  updateInspectionSection(formData: any) {
    return this.commonService.put(`${urlConstant.Inspection.updateInspectionSection}/${formData.id}`, formData)
  }

  addInspectionItem(formData: any) {
    return this.commonService.post(urlConstant.Inspection.addInspectionItem, formData)

  }

  updateInspectionItem(formData: any) {
    return this.commonService.put(`${urlConstant.Inspection.updateInspectionItem}/${formData.id}`, formData)

  }

  updateItemRepairCost(formData:any){
    return this.commonService.put(`${urlConstant.Inspection.updateItemRepairCost}/${formData.id}`, formData)
  }

  deleteItem(id:string){
    return this.commonService.get<any>(urlConstant.Inspection.deleteInpectionItem + '/' + id)
  }

  addInspectionRule(formData: any) {
    return this.commonService.post(urlConstant.Inspection.addInspectionRule, formData)

  }

  updateInspectionRule(formData: any) {
    return this.commonService.put(urlConstant.Inspection.updateInspectionRule, formData)
  }

  getAllInspectionRules(formData: any) {
    const queryParam = Globals.jsonToQueryString(formData);
    return this.commonService.get<any>(`${urlConstant.Inspection.getAllInspectionRules}?${queryParam}`)
  }

  deleteInspectionRule(formData: any) {
    return this.commonService.get(`${urlConstant.Inspection.deleteInspectionRule}/${formData.id}/${formData.deleted}`)
  }

  getInspectionRuleById(id: any) {
    return this.commonService.get<any>(urlConstant.Inspection.getInspectionRuleById + '/' + id+'?fetchHistory=true')
  }

  upcomingDateDiff(inspectionDate) {
    if (!inspectionDate) return false;
    const day = moment().add(15, 'd');
    const startDate = moment(inspectionDate);
    return startDate.isBefore(day);
  }

  isOverDue(inspectionDate) {
    if (!inspectionDate) return false;
    const startDate = moment(inspectionDate);
    const toDay = moment(new Date());
    return startDate.isBefore(toDay);
  }

  isToday(inspectionDate) {
    if (!inspectionDate) return false;
    const startDate = moment(inspectionDate);
    const toDay = moment(new Date());
    return toDay.isSame(startDate);
  }

  propertySection(propertyDetail) {
    const propertySections = [];
    if (!propertyDetail) return;
    if (propertyDetail.bedRoom > 0) {
      for (let i = 0; i < propertyDetail.bedRoom; i++) {
        const name = "Bed Room";
        let size = propertyDetail.bedRoom > 1 ? ` #${i + 1}` : '';
        propertySections.push({name: `${name}${size}`});
      }
    }
    if (propertyDetail.livingRoom > 0) {
      for (let i = 0; i < propertyDetail.livingRoom; i++) {
        const name = "Living Room";
        let size = propertyDetail.livingRoom > 1 ? ` #${i + 1}` : '';
        propertySections.push({name: `${name}${size}`});
      }
    }
    if (propertyDetail.bathRoom > 0) {
      for (let i = 0; i < propertyDetail.bathRoom; i++) {
        const name = "Bath Room";
        let size = propertyDetail.bathRoom > 1 ? ` #${i + 1}` : '';
        propertySections.push({name: `${name}${size}`});
      }
    }
    if (propertyDetail.balcony > 0) {
      for (let i = 0; i < propertyDetail.balcony; i++) {
        const name = "Balcony";
        let size = propertyDetail.balcony > 1 ? ` #${i + 1}` : '';
        propertySections.push({name: `${name}${size}`});
      }
    }
    if (propertyDetail.kitchen > 0) {
      for (let i = 0; i < propertyDetail.kitchen; i++) {
        const name = "Kitchen";
        let size = propertyDetail.kitchen > 1 ? ` #${i + 1}` : '';
        propertySections.push({name: `${name}${size}`});
      }
    }
    if (propertyDetail.additionalPropertyDetails.length > 16) {
      const name = "Additional Room";
      propertyDetail.additionalPropertyDetails.map( (x, i:number) => {
        if(x.propertyAddtionalKey === 'additionalRoom') {
          propertySections.push({name: x.propertyAddtionalType});
        }
      })
    }
    return propertySections
  }

  createServiceRequest(ticket:any){
    return this.commonService.post(urlConstant.ServiceRequest.tickets, ticket)
  }

  getAuthInspection(id: any, f_doc?: boolean, f_service?: boolean){
    const params = {};
    params['f_doc'] = f_doc;
    params['f_service'] = f_service;
    const query = Object.keys(params).filter(k=>params[k]).map((k, index) => {
      return `${k}=${params[k]}`;
    }).join('&');
    return this.commonService.get<any>(`${urlConstant.Auth.getAuthInspection}/${id}?${query}`);
  }

  approvedInspectionStatus(data:any){
    return this.commonService.post(urlConstant.Auth.approvedInspectionStatus, data)
  }

  addInspectionOpenUrl(data:any){
    return this.commonService.post(urlConstant.Auth.addInspectionOpenUrl, data)
  }

  saveTemplate(data:any) {
    return this.commonService.post(urlConstant.Inspection.saveTemplate, data)
  }

  getTemplate(id:any) {
    return this.commonService.get<any>(urlConstant.Inspection.getTemplate + '/' + id)
  }

  getTemplates(filter: any) {
    const queryParam = Globals.jsonToQueryString(filter);
    return this.commonService.get<any>(`${urlConstant.Inspection.getTemplates}?${queryParam}`)
  }

  updateTemplate(data:any) {
    return this.commonService.put(urlConstant.Inspection.updateTemplate + '/' + data.id , data.templateData)
  }

  deleteTemplate(id:any) {
    return this.commonService.delete(urlConstant.Inspection.deleteTemplate, id);
  }

  saveTemplateSection(data:any) {
    return this.commonService.post(urlConstant.Inspection.saveSection, data)
  }

  updateTemplateSection(data:any) {
    return this.commonService.put(urlConstant.Inspection.updateSection, data)
  }

  deleteTemplateSection(id:any) {
    return this.commonService.delete(urlConstant.Inspection.deleteSection, id);
  }

  deleteDoc(id:any){
    return this.commonService.delete(urlConstant.Inspection.deleteDoc, id);
  }

  saveTemplateSectionItem(data:any) {
    return this.commonService.post(urlConstant.Inspection.saveItem, data)
  }

  updateTemplateSectionItem(data:any) {
    return this.commonService.put(urlConstant.Inspection.updateItem, data)
  }

  deleteTemplateSectionItem(id:any) {
    return this.commonService.delete(urlConstant.Inspection.deleteItem, id);
  }

  sendEmailByInspectionId(data: any){
    return this.commonService.post(urlConstant.Inspection.sendingEmailByInspectionId, data)
  }

  calculate(inspection: any) {
    // const itemPrice = (inspection.sections || []).map(t => t.inspectionItems).flat().filter(t => !!t)
    //   .filter(t => !t.tickets)
    //   .map(t => t.inspectionRepairCosts).flat().filter(t => !!t)
    //   .map(t => t.price).reduce((s, t) => s + t, 0);

    // const ticketEstimatePrice = (inspection.sections || []).map(t => t.inspectionItems).flat().filter(t => !!t)
    //   .map(t => t.tickets).flat().filter(t => !!t)
    //   .map(t => t.estimates).flat().filter(t => !!t)
    //   .map(t => t.amount).reduce((s, t) => s + t, 0);

    // const newCost = (inspection.sections || []).map(t => t.inspectionItems).filter(t => !!t).flat().filter(t => !!t).map(item => {
    //   let amount = [item].map(t => t.tickets).filter(t => !!t).flat().filter(t => !!t)
    //           .map(t => parseFloat(t.totalAmount)).reduce((s, t) => s + t, 0)
    //   console.log('my amount',amount);
    //   if (!!amount){
        
    //     return amount;
    //   } 
    //   amount = [item].map(t => t.inspectionRepairCosts).filter(t => !!t).flat().filter(t => !!t).map(t => t.price).reduce((s, t) => s + t, 0);
    //   return amount;
    // })
    // .reduce((s, t) => s + t, 0);

    const newCost = (inspection.sections || [])
  .map(t => t.inspectionItems)
  .filter(t => !!t)
  .flat()
  .filter(t => !!t)
  .map(item => {
    // Calculate the total amount from tickets
    let amount = [item]
      .map(t => t.tickets)
      .filter(t => !!t)
      .flat()
      .filter(t => !!t)
      .map(t => parseFloat(t.totalAmount)) // Ensure totalAmount is treated as a number
      .reduce((s, t) => s + t, 0);

    // If the amount from tickets is 0, calculate the amount from inspectionRepairCosts
    if (!amount) {
      amount = [item]
        .map(t => t.inspectionRepairCosts)
        .filter(t => !!t)
        .flat()
        .filter(t => !!t)
        .map(t => parseFloat(t.price)) // Ensure price is treated as a number
        .reduce((s, t) => s + t, 0);
    }

    return amount;
  })
  .reduce((s, t) => s + t, 0); // Sum all the amounts

  return parseFloat(newCost.toFixed(2));
  }


  getDocumentByDocumentId(documentId, callback) {
    this.commonService.get<any>(urlConstant.Property.getDocumentByDocumentId + '?documentId=' + documentId).subscribe((res) => {
      if (res.Status === '200') {
        if (callback) {
          callback(res.data.Document)
        }
      }
    }, (error) => {
      if (error != null) {
        this.toasterService.pop('error', 'Error', error.message);
      }
    });
  }

  verifyInspection(id: any) {
    return this.commonService.get<any>(urlConstant.Inspection.verifyInspectionByOtp + '/' + id);
  }

  checkInspectionOtp(data: any) {
    return this.commonService.get<any>(urlConstant.Inspection.checkInspectionOtp + '/' + data.id + '/' + data.otp);
  }

  ticketAddToItem(ticket, itemMap, estimates) {
    if (!estimates) {
      estimates = [];
    }
    const itemId = ticket.groupLevel1;
    if (itemMap[itemId]) {
      if (!itemMap[itemId].tickets) {
        itemMap[itemId].tickets = [];
      }
      itemMap[itemId].tickets.push(ticket);

      if (itemMap[itemId].inspectionRepairCosts) {
        const irc = itemMap[itemId].inspectionRepairCosts.find(repairCost => repairCost.categoryId === ticket.categoryId);
        if (irc) {
          irc['ticket'] = ticket;
        }
      }
      itemMap[itemId].tickets.map(ticket => {
        ticket['estimates'] = estimates.filter(es => es.ticketId === ticket.id);
        ticket['estimates'].map(estimate => {
          if (!ticket.amount) {
            ticket['amount'] = estimate.amount
          } else {
            ticket.amount = estimate.amount + ticket.amount
          }
        });
      })
    }
  }

  inspectionRepairStatus(data:any){
    return this.commonService.put(urlConstant.Auth.inspectionRepairStatus, data);
  }

  getAllCities(userId){
    return this.commonService.get<any>(urlConstant.Property.getAllCities + '/' + userId);
  }

  saveInspectionAutoInitiator(data: any){
    return this.commonService.post(urlConstant.Inspection.saveInspectionAutoInitiator, data);
  }

  updateInspectionAutoInitiator(data: any){
    return this.commonService.put(urlConstant.Inspection.updateInspectionAutoInitiator + '/' + data.id, data);
  }
  deleteInspectionAutoInitiator(data: any){
    return this.commonService.post(urlConstant.Inspection.deleteInspectionAutoInitiator, data);
  }
  getInspectionAutoInitiator(id: any){
    return this.commonService.get<any>(urlConstant.Inspection.getInspectionAutoInitiator + '/' + id);
  }
  getAllInspectionAutoInitiator() {
    return this.commonService.get<any>(urlConstant.Inspection.getInspectionAutoInitiator);
  }

  inspectionAutoInitiatorEnable(data: any){
    return this.commonService.put(urlConstant.Inspection.inspectionAutoInitiatorEnable + '/' + data.id, data);
  }

}
